module.exports = __webpack_public_path__ + "img/personnel.fff446fd.svg";